module.exports = __webpack_public_path__ + "static/media/mdi-check.9729b6b6.svg";